import { useQuery } from "@tanstack/react-query";
import { get, post } from "./divertidogsApiUtils";
import { TipoServicio } from "./ventasServicios";
import { eliminar as eliminarGuarderia } from "./agendamientosGuarderiaServicios";
import { eliminar as eliminarHotel } from "./agendamientosHotelServicios";
import { eliminar as eliminarSpa } from "./agendamientosSpaServicios";

export interface AgendamientoResumido {
  id: string;
  fechaAgendamiento: string;
  tipoServicio: TipoServicio;
  mascota: string;
  idVenta: string;
  estaActivo: boolean;
}

export const buscarAgendamientosDeVenta = (
  idVenta: string
): Promise<AgendamientoResumido[] | undefined> => {
  return get<AgendamientoResumido[]>(`agendamientos?idVenta=${idVenta}`);
};

export const QUERY_KEY_BUSCAR_AGENDAMIENTOS_VENTA =
  "QUERY_KEY_BUSCAR_AGENDAMIENTOS_VENTA";

export const useBuscarAgendamientosDeVenta = (
  idVenta: string,
  enabled: boolean
) => {
  return useQuery({
    queryKey: [QUERY_KEY_BUSCAR_AGENDAMIENTOS_VENTA, idVenta],
    queryFn: async () => await buscarAgendamientosDeVenta(idVenta),
    enabled: enabled,
  });
};

export const QUERY_KEY_ES_AGENDAMIENTO_CANCELABLE =
  "QUERY_KEY_ES_AGENDAMIENTO_CANCELABLE";

export type EsAgendamientoCancelableProps = Pick<
  AgendamientoResumido,
  "id" | "tipoServicio"
>;
const esAgendamientoCancelable = async ({
  id,
  tipoServicio,
}: EsAgendamientoCancelableProps): Promise<boolean | undefined> => {
  return get<boolean>(
    `agendamientos/${id}/cancelable?tipoServicio=${tipoServicio}`
  );
};

export const useEsAgendamientoCancelable = (
  props: EsAgendamientoCancelableProps | undefined
) =>
  useQuery({
    queryKey: [QUERY_KEY_ES_AGENDAMIENTO_CANCELABLE],
    enabled: !!props,
    queryFn: async () => await esAgendamientoCancelable(props!!),
  });

export const eliminar = async ({
  idAgendamiento,
  tipoServicio,
}: {
  idAgendamiento: string;
  tipoServicio: TipoServicio;
}) => {
  switch (tipoServicio) {
    case "GUARDERIA": {
      await eliminarGuarderia(idAgendamiento);
      break;
    }
    case "ENTRENAMIENTO": {
      throw Error("Eliminacion de entrenamiento no soportado");
    }
    case "HOTEL": {
      await eliminarHotel(idAgendamiento);
      break;
    }
    case "SPA": {
      await eliminarSpa(idAgendamiento);
      break;
    }
    case "TRANSPORTE": {
      throw Error("Eliminacion de entrenamiento no soportado");
    }
  }
};

export type AgendamientoCarritoResponse = { idVenta: string };

export const agendarDeCarrito = async () => {
  return await post<void, AgendamientoCarritoResponse>("agendamientos");
};
